<template>
  <div class="search-field">
    <input
      type="text"
      :value="value || currentValue"
      :placeholder="placeholder"
      class="search-field__input"
      @input="onInput($event.target.value)"
    >

    <div
      class="icon icon-search"
      @click="clickSearchIcon"
    />
  </div>
</template>
<script>
  export default {
    name: 'SearchField',

    props: {
      value: {
        type: String,
        default: ''
      },
      placeholder: String
    },

    data () {
      return {
        currentValue: ''
      }
    },

    methods: {
      clickSearchIcon () {
        this.$emit('clickSearchIcon')
      },

      onInput (value) {
        this.currentValue = value
        this.$emit('input', value)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .search-field {
    position: relative;
    display: flex;
    padding: 7px 60px 7px 30px;
    font-size: 16px;
    background-color: $c-white;

    &__input {
      flex-grow: 1;
      height: 46px;
      padding: 7px 0;
      overflow: hidden;
      font-size: 16px;
      font-weight: bold;
      color: $c-gray-dark;
      text-overflow: ellipsis;
      white-space: nowrap;
      border: none;
      outline: none;
      caret-color: $c-active;
    }

    .icon {
      position: absolute;
      top: 50%;
      right: 25px;
      padding-right: 0;
      font-size: 20px;
      line-height: 45px;
      color: $c-active;
      cursor: pointer;
      transform: translateY(-50%);
    }
  }
</style>
